export default {
  SEARCH_CATALOG_ALLIANZ_DOCUMENT_TYPE_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_DOCUMENT_TYPE_QUERY'),
  CATALOG_ALLIANZ_DOCUMENT_TYPE_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_DOCUMENT_TYPE_REPOSITORY'),
  CATALOG_ALLIANZ_DOCUMENT_TYPE_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_DOCUMENT_TYPE_STATE_MANAGER'),
};
